/* global angular */
(function () {
  'use strict';

  angular.module('wsLrs.directives').
  /**
   * @params until {function|boolean} A scope expression that, when evaluated to false, will hide this loader
   */

  directive('faLoader', [function () {
    return {
      scope: {
        until: '<'
      },
      template: "\n                <i class=\"fas fa-spinner fa-pulse brand-color my-3\" ng-class=\"classes\" ng-hide=\"until\"></i>\n            ",
      link: function link(scope, elem, attrs) {
        scope.classes = [];
        var size = attrs.size ? "fa-".concat(attrs.size) : 'fa-3x';
        scope.classes.push(size);

        // Add all dynamic classes before this join
        scope.classes = scope.classes.join(' ');
      }
    };
  }]);
})();
